import { action, makeObservable, observable } from "mobx";
import { CountId, DropDownModel } from "./dropDown";
import { ErrorMessages } from "./errorMessage";
import Validator from "./validator";
import { RisksNetworkResponseModel, RisksNetworkTypes } from "./risksNetwork";
import { SimpleAdditionalInsuranceModel } from "./additionalInsurances";
import { CalculateStore } from "../stores/calculateStore";

export interface CatAndDogModel extends SimpleAdditionalInsuranceModel {
  catsCount: CountId;
  dogsCount: CountId;
  insuranceSum: CatAndDogInsuranceSumId;
  errorMessage: string;

  catAndDogCount: () => number;
  validateCatAndDogCount: () => void;
  getValuesFromRetrievedCalculation?: (insurance: any, calculateStore: CalculateStore) => void;
}

export enum CatAndDogInsuranceSumId {
  twoThousands = "SUM_2000",
  fourThousands = "SUM_4000"
}

export const CatAndDogCountDropDown: DropDownModel[] = [
  {
    id: CountId.zero,
    displayName: "0"
  },
  {
    id: CountId.one,
    displayName: "1"
  },
  {
    id: CountId.two,
    displayName: "2"
  },
  {
    id: CountId.three,
    displayName: "3"
  },
  {
    id: CountId.four,
    displayName: "4"
  }
];

export const CatAndDogInsuranceSumDropDown: DropDownModel[] = [
  {
    id: CatAndDogInsuranceSumId.twoThousands,
    displayName: "2 000 zł"
  },
  {
    id: CatAndDogInsuranceSumId.fourThousands,
    displayName: "4 000 zł"
  }
];

interface DefaultCatAndDogArguments {
  checked: boolean;
  risksNetworkValue?: RisksNetworkTypes | undefined;
  getRisksNetworkValue?: (response: RisksNetworkResponseModel) => RisksNetworkTypes;
  catsCount: CountId;
  dogsCount: CountId;
  errorMessage: string;
  insuranceSum: CatAndDogInsuranceSumId;
  rate: number | null;
}

export class DefaultCatAndDog implements CatAndDogModel {
  @observable checked: boolean;
  @observable risksNetworkValue?: RisksNetworkTypes | undefined;
  @observable getRisksNetworkValue?: (response: RisksNetworkResponseModel) => RisksNetworkTypes;
  @observable catsCount: CountId;
  @observable dogsCount: CountId;
  @observable insuranceSum: CatAndDogInsuranceSumId;
  @observable rate: number | null;
  @observable errorMessage: string;

  constructor(args?: DefaultCatAndDogArguments) {
    makeObservable(this);

    this.checked = args?.checked !== undefined ? args.checked : false;
    this.risksNetworkValue = args?.risksNetworkValue !== undefined ? args.risksNetworkValue : undefined;
    this.getRisksNetworkValue = (response: RisksNetworkResponseModel) => response.catAndDog;
    this.rate = args?.rate !== undefined ? args.rate : null;
    this.catsCount = args?.catsCount !== undefined ? args.catsCount : CountId.zero;
    this.dogsCount = args?.dogsCount !== undefined ? args.dogsCount : CountId.zero;
    this.insuranceSum = args?.insuranceSum !== undefined ? args.insuranceSum : CatAndDogInsuranceSumId.twoThousands;
    this.errorMessage = "";
  }

  @action
  public validateCatAndDogCount = () => {
    if (this.checked) {
      if (!Validator.max(4)(this.catAndDogCount())) {
        this.errorMessage = ErrorMessages.catAndDog.maxCount;
      } else if (!Validator.min(1)(this.catAndDogCount())) {
        this.errorMessage = ErrorMessages.catAndDog.zeroCount;
      }
      else {
        this.errorMessage = "";
      }
    }
    else {
      this.errorMessage = "";
    }
  }

  @action
  public catAndDogCount = () => {
    return Number(this.catsCount) + Number(this.dogsCount);
  }

  @action
  public getValuesFromRetrievedCalculation = (insurance: any) => {
    this.catsCount = insurance.catAndDog?.catsCount ?? CountId.zero;
    this.dogsCount = insurance.catAndDog?.dogsCount ?? CountId.zero;
    this.insuranceSum = insurance.catAndDog?.insuranceSum ?? CatAndDogInsuranceSumId.twoThousands;
    this.checked = !!insurance.catAndDog;
  }
}
